exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../img/baseline-error-24px.svg"));

// Module
exports.push([module.id, ".kgr-merchandise__paragraph--error-message{margin-top:-12px;line-height:1}.kgr-merchandise__paragraph--error-message:before{content:url(" + ___CSS_LOADER_URL___0___ + ");position:relative;top:6px;display:inline-block;width:24px;height:24px;margin-right:4px}\n", ""]);

